"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubShiftRequestSchema = exports.ShiftSnapshotSchema = exports.TimelineEventSchema = exports.SubShiftStatusSchema = exports.SubShiftTypeSchema = void 0;
const zod_1 = require("zod");
exports.SubShiftTypeSchema = zod_1.z.enum(['cover', 'swap']);
exports.SubShiftStatusSchema = zod_1.z.enum([
    'pending_coworker', 'coworker_declined', 'pending_admin', 'approved', 'denied', 'cancelled',
]);
exports.TimelineEventSchema = zod_1.z.object({
    at: zod_1.z.number(), actorId: zod_1.z.string(), actorRole: zod_1.z.string(),
    kind: zod_1.z.string(), note: zod_1.z.string().optional(),
});
exports.ShiftSnapshotSchema = zod_1.z.object({
    shiftId: zod_1.z.string(), date: zod_1.z.string(), startTime: zod_1.z.string(),
    endTime: zod_1.z.string(), locationId: zod_1.z.string(),
});
exports.SubShiftRequestSchema = zod_1.z.object({
    id: zod_1.z.string(), tenantId: zod_1.z.string(), createdAt: zod_1.z.number(), updatedAt: zod_1.z.number(),
    type: exports.SubShiftTypeSchema,
    requesterId: zod_1.z.string(),
    shift: exports.ShiftSnapshotSchema,
    counterpartyId: zod_1.z.string().optional(),
    counterpartyShift: exports.ShiftSnapshotSchema.optional(),
    assignedSubId: zod_1.z.string().optional(),
    openToEligible: zod_1.z.boolean().default(false),
    reason: zod_1.z.string().optional(),
    status: exports.SubShiftStatusSchema,
    timeline: zod_1.z.array(exports.TimelineEventSchema).default([]),
    adminOverrideReason: zod_1.z.string().optional(),
});
//# sourceMappingURL=subShift.js.map